import type {ContainerProps} from '@/modules/foundation/components/container';
import {Container} from '@/modules/foundation/components/container';
import {cn} from '@/modules/foundation/shared/tailwind';
import type {ContentBlockOptions} from '@/sanity/schemas/types';

export interface ContentBlockContainerProps extends ContainerProps {
	options?: Omit<ContentBlockOptions, '_type'> & {
		fullWidth?: boolean;
	};
	insideToc?: boolean;
}

export const ContentBlockContainer = ({
	children,
	className,
	options,
	insideToc,
	...rest
}: ContentBlockContainerProps) => {
	const hasThemeColor =
		options?.themeColor === 'blue' ||
		options?.themeColor === 'green' ||
		options?.themeColor === 'orange' ||
		options?.themeColor === 'grey';

	return (
		<Container
			className={cn(
				[
					hasThemeColor && [getThemeColor(options?.themeColor), 'py-14'],
					options?.showDivider && 'border-t border-grey-border py-14',
					insideToc && hasThemeColor && ['p-4', 'md:p-8', 'rounded-lg'],
				],
				className,
			)}
			spacingBottom={options?.spacingBottom}
			spacingTop={options?.spacingTop}
			width={options?.fullWidth ? 'screen' : (options?.width ?? 'normal')}
			{...rest}
		>
			{children}
		</Container>
	);
};

const getThemeColor = (color: ContentBlockOptions['themeColor']) => {
	switch (color) {
		case 'grey':
			return 'bg-grey-95';
		case 'green':
			return 'bg-success-90';
		case 'orange':
			return 'bg-warning-90';
		case 'blue':
			return 'bg-primary-90';
		case 'default':
			return '';
		default:
			return '';
	}
};
